module.exports = __webpack_public_path__ + "static/media/login.22660f0e.png";